import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 1600px;
  min-height: 100%;
  padding: 25px;
`;

export const NavigationContainer = styled.div`
  position: sticky;
  top: 0px;
  z-index: 99;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
  height: 75px;
  padding-top: 15px;
  margin-top: 10px;
  border-bottom: 1px solid var(--color-grey-4);
  background-color: var(--color-white);
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex: 1;
  margin-top: 25px;
`;

export const NotificationContainer = styled.div`
  position: sticky;
  top: 100px;
  width: 370px;
  flex-shrink: 0;
  flex-basis: 370px;
  padding-left: 25px;
  max-height: calc(100vh - 125px);

  & > * {
    height: 100%;
  }
`;

export const Filters = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
`;

export const Search = styled.div`
  width: 345px;
  margin-left: 25px;
`;
